import { BaseModalOptions } from 'base-modal';
import { Importer } from 'lazy-loader-service';
import { ModalWrapperService } from 'base-modal';
import { BehaviorSubject } from 'rxjs';

export const primeNgModalImporter = () => {
  return import('./primeng-modal.component').then((file) => {
    return file.PrimengModalComponent;
  });
};

export class PrimengModalImporter extends Importer<
  typeof primeNgModalImporter
> {
  constructor(param: {
    openModalEmitter: BehaviorSubject<BaseModalOptions>;
    closeModalEmitter: BehaviorSubject<boolean>;
    wrapperServiceInstance: ModalWrapperService;
    initWrapperEmitter: BehaviorSubject<boolean>;
  }) {
    super({
      loader: primeNgModalImporter,
      param,
    });
  }
}
